export default __webpack_public_path__ + "img/3c4915752f3247186224e73a6b302b05.svg";